export default __webpack_public_path__ + "static/media/05.1b750ba5.jpg";